import axios from 'axios';

export default function setAppUltimateHeader(placeId) {
    axios.defaults.headers.common['app_ultimate'] = 1;
}